module.exports = __webpack_public_path__ + "static/media/jo.118c5546.svg";